import React, { useEffect, useState } from 'react';
//import { useNavigate } from 'react-router-dom';
import { rlsBypassQuery } from '../api/rlsBypassQuery';
import '../style.css';
const MREdata = () => {
  const [MRE, setMREData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [searchColumn, setSearchColumn] = useState(""); 
const [searchQuery, setSearchQuery] = useState('');
//const navigate = useNavigate();
  // Pagination and view states
  const [showMore, setShowMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 100;
  //const [searchColumn, setSearchColumn] = useState("");

  useEffect(() => {
    const fetchMREData = async () => {
      try {
        const data = await rlsBypassQuery({
          table: 'customer_model_reports',
          select: '*',
          orderBy: { column: 'id', ascending: true },
          limit: 1000,
        });

        const nonNullStorageRows = data.filter(
          (item) => item?.storage_path !== null && item?.storage_path !== undefined
        );
        setMREData(nonNullStorageRows);
      } catch (error) {
        console.error('Error fetching MRE data:', error);
        setMREData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMREData();
  }, []);

  // Decide visible data depending on showMore and pagination
  let visibleData = [];
  if (!showMore) {
    visibleData = MRE.slice(0, 5);
  } else {
    const totalPages = Math.ceil(MRE.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    visibleData = MRE.slice(startIndex, startIndex + pageSize);
  }

  const totalPages = Math.ceil(MRE.length / pageSize);

  const handleToggleExpand = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  const handleViewMore = () => {
    setShowMore(true);
    setCurrentPage(1);
  };
  console.log(' Actual data:', MRE);

const filteredReports = MRE.filter(item => {
  const columnValue = searchColumn.includes('.') 
    ? searchColumn.split('.').reduce((obj, key) => obj?.[key], item)
    : item[searchColumn];

  return columnValue?.toString().toLowerCase().includes(searchQuery.toLowerCase());
  });
  console.log(' data:', filteredReports);

//Calling the Mdlproect and pass the value
/*const handleBuyNow = (MRE) => {
  
  const query = new URLSearchParams({
    fromExternal: 'true', // helps Project B identify this came externally
    make: MRE.make,
    model: MRE.model,
    chassisCode: MRE.chassis_code,
    startDate: MRE.start_date,
    endDate: MRE.end_date,
    mreId: MRE.id,
  }).toString();
const url = `https://www.mdlreports.com.au/new-order?${query}`;
  window.open(url, '_blank'); 
  //window.location.href = `https://www.mdlreports.com.au/new-order?${query}`;
};*/
/*const handleBuyNow = (item) => {
  //const orderWindow = window.open('https://www.mdlreports.com.au/new-order', '_blank');
  navigate('https://www.mdlreports.com.au/new-order', '_blank', {
    state: {
      mreDetails: {
        mrApproval: item.mr_approval,
        make: item.make,
        model: item.model,
        chassisCode: item.chassis_code,
        startDate: item.start_date,
        endDate: item.end_date,
      },
      mreId: item.id,
    },
  });
};*/


const isExpired = (dateStr) => {
  if (!dateStr) return false;

  const parts = dateStr.split('/'); // dd/mm/yyyy
  if (parts.length !== 3) return false;

  const [day, month, year] = parts;

  const expiryDate = new Date(`${year}-${month}-${day}`);
  const today = new Date();

  today.setHours(0, 0, 0, 0);

  return expiryDate < today;
};


const handleBuyNow = (item) => {
  console.log("handleBuyNow called with item:", item); 
  const orderWindow = window.open('https://www.mdlreports.com.au/new-order', '_blank');

  const messageData = {
    type: 'MRE_SELECTED',
    mreId: item.mr_approval,
    mreDetails: {
      mreId: item.mr_approval,
      startDate: item.start_date,
      endDate: item.end_date,
      make: item.make,
      model: item.model,
      chassisCode:item.chassis_code,
       mrApproval: item.mr_approval,
    },
   
  };
  let attempt=0;
  const maxattempt=20;
   const timer = setInterval(() => {
    if (orderWindow && !orderWindow.closed) {
      try {
        orderWindow.postMessage(messageData, 'https://www.mdlreports.com.au');
       // console.log("Message sent to new order window.");
        clearInterval(timer); //sent successfully
      } catch (err) {
       // console.warn("Retrying to send message...");
      }
    } else {
      clearInterval(timer); // window closed
    }

    if (++attempt >= maxattempt) {
      //console.error("Could not send message.");
      clearInterval(timer);
    }
  }, 500);
};






  /*const timer = setInterval(() => {

    
    if (orderWindow && orderWindow.postMessage) {
      orderWindow.postMessage(messageData, 'https://www.mdlreports.com.au'); 
      clearInterval(timer);
    }
  }, 500);
};*/



  return (
    
    
      <div className="container-fluid shadow"style={{ backgroundColor: '#eef2f7'}}>
        <h1 className="mb-4 text-center heading-title fw-bold">Model Reports</h1>
        <p className='text-muted mb-4 text-center'>Our Model Report table displays all reports we currently offer, including key specifications and details. 
          Easily search, sort, and find the report that fits your requirements.</p>
              
<div className="d-flex justify-content-end mb-3">
  <div className="d-flex flex-column flex-md-row align-items-end gap-2">

    {/* Label */}
    <div>
      <span className="fw-bold text-dark">Search By</span>
    </div>

    {/* Select Dropdown */}
    <div>
      <select
        className="form-select form-select-sm border-dark"
        style={{ maxWidth: '200px' }}
        value={searchColumn}
        onChange={(e) => setSearchColumn(e.target.value)}
      >
        <option value="" disabled>Select</option>
        <option value="make">Make</option>
        <option value="model">Model</option>
        <option value="chassis_code">Chassis Code</option>
        <option value="body_type">BodyType</option>
        <option value="sevs_entry">Sevs Entry</option>
        <option value="mr_approval">MR Approval</option>
      </select>
    </div>

    {/* Text Input */}
    <div>
      <input
        type="text"
        className="form-control form-control-sm border-dark"
        style={{ maxWidth: '200px' }}
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        disabled={!searchColumn}
      />
    </div>

  </div>
</div>

  
  
        {loading ? (
          <div className="text-center">Loading...</div>
        
        ) : (
          <>
            <div className='table-scroll-container'
             style={{
    maxHeight: '920px',
    overflowY: 'auto',
    overflowX: 'hidden',
  }}
            >
              
  <div className="row">
    <div className="col-12">
              <div className="table " >
                <table className="table table-hover mre-table no-col-borders">
                  <thead className="sticky-top table-dark" >
                    <tr>
                      <th>S/N</th>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Chassis Code</th>
                      <th>BodyType</th>
                      <th>Sevs Entry</th>
                      <th>MR Approval</th>
                      
                      
  
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { (searchQuery ? filteredReports:visibleData).length === 0 ? (
                       <tr>
              <td colSpan="8" className="text-center text-danger">
                No model data found.
              </td>
            </tr>
          ) : (

                    (searchQuery ? filteredReports : MRE).map((item, index) => {
                      const expired = isExpired(item.sevs_expiry);
                      return (
                        <React.Fragment key={item.id}>
                        <tr className={expired ? "expired-row" : ""}>
                            <td data-label="Slno">{index+1}</td>
                            <td data-label="Make">{item.make}</td>
                            <td data-label="Model">{item.model}</td>
                            <td data-label="Chassis Code">{item.chassis_code}</td>
                            <td data-label="Body Type">{item.body_type}</td>
                          <td data-label="Sevs Entry">
  <div>{item.sevs_entry}</div>

  {expired && (
  <div
    style={{
      marginTop: "4px",
      display: "inline-block",
      fontSize: "10px",
      fontWeight: "600",
      letterSpacing: "0.5px",
      color: "#ff0505",
      backgroundColor: "rgba(255, 0, 0, 0.06)",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid rgba(255, 0, 0, 0.15)",
    }}
  >
    EXPIRED
  </div>
)}
</td>
                            <td data-label="MRE Appoval">{item.mr_approval}</td>
                            
                            
                          
                            <td className="text-center">
                              <span
                                style={{ cursor: 'pointer', fontSize: '18px' }}
                                onClick={() => handleToggleExpand(item.id)}
                              >
                                {expandedId === item.id ? <i className="bi bi-chevron-up"></i>  // 👆 Icon when EXPANDED
        : <i className="bi bi-chevron-down"></i> 
    }
                              </span>
                            </td>
                          </tr>
{/*more details*/}
                          {expandedId === item.id && (
                            
                            <tr>
                              
                              <td colSpan="7">
                                
                                {/* Expanded details */}
                                <div className="row custom-colour">
                                  <div className="col-md-3">
                                    <strong>Engine Details</strong>
                                   <p>Option 1 <strong>:</strong>&nbsp;{item.engine_option_1}</p>
                                   {item.engine_option_2&&item.engine_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.engine_option_2}</p>
                                     )}
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Transmission & Drivetrain</strong>
                                    <p>Transmission <strong>:</strong>&nbsp;{item.transmission}<br/>
                                    Drivetrain <strong>:</strong>&nbsp;{item.drivetrain}</p>
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Seat Details</strong>
                                    <p>Option 1 <strong>:</strong>&nbsp;{item.seats_option_1}<br/>
                                    {item.seats_option_2&&item.seats_option_2?.trim()!=='-' && (
                                       <p>Option 2 <strong>:</strong>&nbsp;{item.seats_option_2}</p>
                                     )}
                                     {item.seats_option_3&&item.seats_option_3?.trim()!=='-' && (
                                       <p>Option 3 <strong>:</strong>&nbsp;{item.seats_option_3}</p>
                                     )}</p>
                                  </div>
                                  
                                  <div className="col-md-3">
                                    <strong>Dates</strong>
                                    <p>Start <strong>:</strong>&nbsp;{item.start_date}<br/>
                                    End <strong>:</strong>&nbsp;{item.end_date}</p>
                                    </div>
                                   <div className="col-md-3">
                                    <strong>Reference </strong>
                                    <p>WI Ref <strong>:</strong>&nbsp;{item.mr_wi_reference}<br/>
                                    VC Ref <strong>:</strong>&nbsp;{item.mr_vc_reference}</p>
                                  
                                  
                                    
                                    
                                    
                                  </div>
                                  <div className="col-md-3">
                                    <strong>Requirement</strong>
                                    <p>Origin <strong>:</strong>&nbsp;{item.origin_requirements}<br/>
                                    Body type <strong>:</strong>&nbsp;{item.body_type}<br/>
                                    Cats or km required <strong>:</strong>&nbsp;{item.cats_or_km_required}<br/>
                                    Camper conversion <strong>:</strong>&nbsp;{item.camper_conversion_required}<br/>
                                    Welcab type <strong>:</strong>&nbsp;{item.welcab_type}<br/>
                                    </p>
                                  </div>
                                 <div className="col-md-3">
                                 {item.mr_variation_description&&item.mr_variation_description?.trim()!=='' && (
                                    <div>
                                      <strong>Variation Description</strong>
                                      <p> <strong></strong>&nbsp;{item.mr_variation_description}</p>
                                       
                                     </div>
                                  )}
                                </div>

                               <div className="col-md-3">
  <strong>SEVS Details</strong>

  <p>
    SEVS Expiry :{" "}
    <span
      style={{
        color:
          item.sevs_expiry &&
          isExpired(item.sevs_expiry)
            ? "red"
            : "inherit",
        fontWeight:
          item.sevs_expiry &&
          isExpired(item.sevs_expiry)
            ? "bold"
            : "normal",
      }}
    >
      {item.sevs_expiry || "-"}
    </span>

    {item.sevs_expiry && isExpired(item.sevs_expiry) && (
      <span style={{ color: "red", fontWeight: "bold" }}>
        {" "} (Expired)
      </span>
    )}
  </p>
</div>

                                   
                                 
                            
                                </div>
                                
                              </td>
                              <td colSpan="1 ">
                                
                                <div className="d-flex justify-content-end">
                                 
                                   <button className="btn btn-danger" onClick={() => handleBuyNow(item)} >
                                         Buy Now
                                  </button>
                                   </div>
                              
                              </td>
                              
                            </tr>
                            
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                    
                  
                  </tbody>
                </table>
                </div>
                </div>
              </div>
            </div>

            {/* Show "View More" button if not showing all */}
            {!showMore && MRE.length > 5 && (
              <div className="text-end mt-3">
                
              </div>
            )}

            
          </>
        )}
      </div>
   
   
   
  );

 
};


export default MREdata;

